<template>
  <WithPagination
    v-slot="{ currentPageData }"
    :data="products"
    :is-raised="isRaised"
  >
    <ElTable
      :data="currentPageData"
      :empty-text="$t('APP.IAB.NO_PRODUCTS')"
      row-key="sku"
      class="in-app-purchase-products-table"
    >
      <ElTableColumn
        v-slot="{ row }"
        :label="$t('APP.IAB.PRODUCT_SKU')"
        min-width="200"
      >
        <ElTooltip :content="getStateLabel(row.state)" placement="top">
          <i
            v-if="row.state === 'A'"
            class="in-app-purchase-products-table__icon el-icon-success"
          />
          <i
            v-else
            class="in-app-purchase-products-table__icon el-icon-error"
          />
        </ElTooltip>
        <code>{{ row.sku }}</code>
      </ElTableColumn>

      <ElTableColumn v-slot="{ row }" :label="$t('APP.IAB.PRODUCT_TITLE')">
        {{ row[`title_${normalizedLang}`] }}
      </ElTableColumn>

      <ElTableColumn v-slot="{ row }" :label="$t('APP.IAB.PRODUCT_KIND')">
        {{ translateKindLabel(row.kind) }}
      </ElTableColumn>

      <ElTableColumn v-slot="{ row }" :label="$t('APP.IAB.PRODUCT_PRICE')">
        {{ priceLabel(row.price, $t('RIALS'), $t('FREE')) }}
      </ElTableColumn>

      <ElTableColumn v-slot="{ row }" width="130">
        <div class="text-end">
          <ElButton
            v-if="row.kind !== 'R'"
            plain
            icon="el-icon-edit"
            size="small"
            @click="openEditModal(row)"
          />
        </div>
      </ElTableColumn>
    </ElTable>
  </WithPagination>
</template>

<script>
import { label as priceLabel } from '@/utils/number';
import lang from '@/mixins/lang';
import getKindLabel from '@/utils/apps/kindLabel';
import InAppPurchaseProductModal from './InAppPurchaseProductModal';
import WithPagination from '@@/common/paginations/WithPagination';

export default {
  name: 'InAppPurchaseProductsTable',
  components: { WithPagination },
  mixins: [lang],

  props: {
    products: {
      type: Array,
      default: () => [],
    },
    isRaised: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    priceLabel,

    getStateLabel(state) {
      const stateLabels = {
        A: this.$t('ACTIVE'),
        D: this.$t('DISABLED'),
      };

      return stateLabels[state] || '';
    },

    openEditModal(productData) {
      return this.$modal
        .open({
          component: InAppPurchaseProductModal,
          props: {
            originalProduct: productData,
            confirmButtonText: this.$t('APP.IAB.APPLY_PRODUCT_BTN'),
          },
          title: this.$t('APP.IAB.EDIT_PRODUCT'),
          width: '40%',
        })
        .then(updatedData => {
          if (!updatedData) return;
          this.$emit('edit-product', updatedData);
        });
    },

    translateKindLabel(kind) {
      if (kind === 'R') {
        return this.$t('APP.IAB.TRIAL_SUBSCRIPTION');
      }

      return this.$t(getKindLabel(kind));
    },
  },
};
</script>

<style lang="scss">
.in-app-purchase-products-table {
  &__title {
    font-size: rem-calc(25px);
    font-weight: 400;
  }

  &__description {
    font-size: rem-calc(14px);
    font-weight: 400;
    color: $lb-light-black;
  }

  &__more-info {
    color: $lb-color-primary;
    border-color: $lb-color-primary;
    margin-left: $global-margin * 1;

    @include rtl() {
      margin-left: 0;
      margin-right: $global-margin * 1;
    }
  }

  &__icon {
    font-size: 1.2rem;
    vertical-align: sub;

    &.el-icon-error {
      color: $lb-color-alert;
    }

    &.el-icon-success {
      color: $lb-color-primary;
    }
  }

  code {
    border-radius: 25px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    border-width: 0;
  }
}
</style>
